module.exports = __webpack_public_path__ + "img/sample.2d889b1.jpg";